var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slide-verify',{ref:"slideverify",attrs:{"l":42,"r":10,"w":400,"h":250,"imgs":_vm.picArray,"show":false,"slider-text":"向右滑动完成验证"},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }